<template>
    <div :class="['test-result-wrap', mapping?.[data?.voiceResult] || '']">
        <div class="user-info-title">「<span v-text="data.nickname"></span>」的音色是</div>
        <div class="label-wrap">
            <div class="label-item" v-for="desc in data?.voiceDesc" :key="desc" v-text="desc"></div>
        </div>
        <div class="detail-wrap">
            <div class="detail-row">
                <div class="detail-column">
                    <h2 class="detail-title similar"></h2>
                    <p class="detail-content">
                        <span :class="index === 1 ? 'special' : ''" v-for="(similarSinger, index) in data.similarSinger" :key="index" v-text="similarSinger"></span>
                    </p>
                </div>
                <div class="detail-column">
                    <div class="share-btn" @click="clickShareFun">一键分享</div>
                </div>
            </div>
            <div class="detail-row">
                <div class="detail-column">
                    <h2 class="detail-title cp"></h2>
                    <p class="detail-content" v-text="data.bestCpVoice"></p>
                </div>
                <div class="detail-column">
                    <h2 class="detail-title scarcity"></h2>
                    <p class="detail-content">
                        <span :class="index === 0 ? 'special' : ''" v-for="(voiceRareness, index) in data.voiceRareness" :key="index" v-text="voiceRareness"></span>
                    </p>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script setup>

const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const emit = defineEmits(['share']);

const clickShareFun = () => {
    emit('share');
};

const mapping = {
    '干净阳光の少年音': 'shaonian',
    '温润清朗の青年音': 'qingnian',
    '软糯绵绵の萝莉音': 'mianmian',
    '软糯绵绵の学妹音': 'mianmian',
    '清新甜美の少女音': 'tianmei',
    '元气活力の少女音': 'huoli',
    '温柔悠然の少御音': 'shaoyu',
    '奶声脆脆の萝莉音': 'cuicui',
    '奶声脆脆の稚气音': 'cuicui',
    '明朗盈耳の公子音': 'gongzi',
    '魅力成熟の御姐音': 'yujie',
    '深情磁性の青叔音': 'qingshu',
    '纯净呆萌の正太音': 'zhengtai',
    '纯净呆萌の小霸总': 'zhengtai',
    '雄厚沉稳の大叔音': 'dashu',
    '独具一格の神秘音': 'shenmi',
};
</script>

<style lang="scss" scoped>
.test-result-wrap{
    background-size: 100% auto;
    background-repeat: no-repeat;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .user-info-title{
        flex: none;
        margin: 96px 0 0 48px;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 24px;
        height: 60px;
        font-size: 28px;
        font-weight: 400;
        color: #ffffff;
    }
    .label-wrap{
        flex: auto;
        width: 100%;
        position: relative;
        .label-item{
            flex: none;
            white-space: nowrap;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 18px;
            height: 50px;
            background: #ffffff;
            border: 2px solid #010101;
            border-radius: 28px;
            font-size: 26px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
        }
    }
    .detail-wrap{
        flex: none;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 32px;
        width: 670px;
        height: 316px;
        background: linear-gradient(180deg,rgba(255,255,254,0.80), #fefefc);
        border: 3px solid rgba(54,17,74,0.50);
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        z-index: 2;
        .detail-row{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .detail-column{
                display: flex;
                flex-direction: column;
            }

            .share-btn {
                background: #fde22e;
                text-align: center;
                line-height: 40px;
                border-radius: 30px;
                padding: 10px;
                font-size: 26px;
                width: 140px;
                height: 40px;
                color: #000000;
            }
        }
        .detail-title{
            height: 56px;
            background-repeat: no-repeat;
            background-size: 100%;
            &.similar{
                background-image: url(../imgs/title_similar.png);
                width: 196px;
            }
            &.cp{
                background-image: url(../imgs/title_cp.png);
                width: 212px;
            }
            &.scarcity{
                background-image: url(../imgs/title_scarcity.png);
                width: 214px;
            }
        }
        .detail-content{
            margin-top: 24px;
            font-size: 28px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: #36114a;
            line-height: 28px;
            .special{
                color: #AB09FB;
            }
        }
    }
    &.shaonian{
        background-image: url(../imgs/bg_shaonian.jpg);
        .user-info-title{
            background: #005e6e;
        }
        .label-wrap{
            .label-item{
                color: #06444e;
                &:nth-child(1){
                    top: 395px;
                    left: 139px;
                }
                &:nth-child(2){
                    top: 510px;
                    left: 21px;
                }
                &:nth-child(3){
                    top: 689px;
                    right: 10px;
                }
            }
        }
    }
    &.qingnian{
        background-image: url(../imgs/bg_qingnian.jpg);
        .user-info-title{
            background: #5500ce;
        }
        .label-wrap{
            .label-item{
                color: #2d0862;
                &:nth-child(1){
                    top: 296px;
                    left: 158px;
                }
                &:nth-child(2){
                    top: 636px;
                    left: 68px;
                }
                &:nth-child(3){
                    top: 582px;
                    right: 10px;
                }
            }
        }
    }
    &.mianmian{
        background-image: url(../imgs/bg_mianmian.jpg);
        .user-info-title{
            background: #910023;
        }
        .label-wrap{
            .label-item{
                color: #910023;
                &:nth-child(1){
                    top: 367px;
                    left: 34px;
                }
                &:nth-child(2){
                    top: 564px;
                    left: 120px;
                }
                &:nth-child(3){
                    top: 686px;
                    right: 15px;
                }
            }
        }
    }
    &.tianmei{
        background-image: url(../imgs/bg_tianmei.jpg);
        .user-info-title{
            background: #770052;
        }
        .label-wrap{
            .label-item{
                color: #770052;
                &:nth-child(1){
                    top: 458px;
                    left: 47px;
                }
                &:nth-child(2){
                    top: 680px;
                    left: 106px;
                }
                &:nth-child(3){
                    top: 578px;
                    right: 40px;
                }
            }
        }
    }
    &.huoli{
        background-image: url(../imgs/bg_huoli.jpg);
        .user-info-title{
            background: #502ca0;
        }
        .label-wrap{
            .label-item{
                color: #502ca0;
                &:nth-child(1){
                    top: 286px;
                    left: 48px;
                }
                &:nth-child(2){
                    top: 586px;
                    left: 158px;
                }
                &:nth-child(3){
                    top: 694px;
                    right: 70px;
                }
            }
        }
    }
    &.shaoyu{
        background-image: url(../imgs/bg_shaoyu.jpg);
        .user-info-title{
            background: #ad660a;
        }
        .label-wrap{
            .label-item{
                color: #ad660a;
                &:nth-child(1){
                    top: 340px;
                    left: 102px;
                }
                &:nth-child(2){
                    top: 718px;
                    left: 74px;
                }
                &:nth-child(3){
                    top: 602px;
                    right: 32px;
                }
            }
        }
    }
    &.cuicui{
        background-image: url(../imgs/bg_cuicui.jpg);
        .user-info-title{
            background: #06688e;
        }
        .label-wrap{
            .label-item{
                color: #06688e;
                &:nth-child(1){
                    top: 304px;
                    left: 72px;
                }
                &:nth-child(2){
                    top: 584px;
                    left: 189px;
                }
                &:nth-child(3){
                    top: 750px;
                    right: 32px;
                }
            }
        }
    }
    &.gongzi{
        background-image: url(../imgs/bg_gongzi.jpg);
        .user-info-title{
            background: #f66500;
        }
        .label-wrap{
            .label-item{
                color: #713307;
                &:nth-child(1){
                    top: 304px;
                    left: 127px;
                }
                &:nth-child(2){
                    top: 518px;
                    left: 60px;
                }
                &:nth-child(3){
                    top: 746px;
                    right: 15px;
                }
            }
        }
    }
    &.gongzi{
        background-image: url(../imgs/bg_gongzi.jpg);
        .user-info-title{
            background: #f66500;
        }
        .label-wrap{
            .label-item{
                color: #713307;
                &:nth-child(1){
                    top: 304px;
                    left: 127px;
                }
                &:nth-child(2){
                    top: 518px;
                    left: 60px;
                }
                &:nth-child(3){
                    top: 746px;
                    right: 15px;
                }
            }
        }
    }
    &.yujie{
        background-image: url(../imgs/bg_yujie.jpg);
        .user-info-title{
            background: #502ca0;
        }
        .label-wrap{
            .label-item{
                color: #4e0077;
                &:nth-child(1){
                    top: 278px;
                    left: 86px;
                }
                &:nth-child(2){
                    top: 554px;
                    left: 74px;
                }
                &:nth-child(3){
                    top: 774px;
                    right: 32px;
                }
            }
        }
    }
    &.qingshu{
        background-image: url(../imgs/bg_qingshu.jpg);
        .user-info-title{
            background: #000a6e;
        }
        .label-wrap{
            .label-item{
                color: #06444e;
                &:nth-child(1){
                    top: 482px;
                    left: 139px;
                }
                &:nth-child(2){
                    top: 706px;
                    left: 74px;
                }
                &:nth-child(3){
                    top: 636px;
                    right: 32px;
                }
            }
        }
    }
    &.zhengtai{
        background-image: url(../imgs/bg_zhengtai.jpg);
        .user-info-title{
            background: #e90000;
        }
        .label-wrap{
            .label-item{
                color: #962a02;
                &:nth-child(1){
                    top: 323px;
                    left: 137px;
                }
                &:nth-child(2){
                    top: 532px;
                    left: 19px;
                }
                &:nth-child(3){
                    top: 771px;
                    right: 68px;
                }
            }
        }
    }
    &.dashu{
        background-image: url(../imgs/bg_dashu.jpg);
        .user-info-title{
            background: #6e2b00;
        }
        .label-wrap{
            .label-item{
                color: #361500;
                &:nth-child(1){
                    top: 466px;
                    left: 180px;
                }
                &:nth-child(2){
                    top: 566px;
                    left: 104px;
                }
                &:nth-child(3){
                    top: 705px;
                    right: 40px;
                }
            }
        }
    }
    &.shenmi{
        background-image: url(../imgs/bg_shenmi.jpg);
        .user-info-title{
            background: #36920b;
        }
        .label-wrap{
            .label-item{
                display: none;
            }
        }
        .detail-wrap{
            display: none;
        }
    }
}
</style>